import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// vendored from packages/editor/editor-plugin-ai/src/experience-application/screens-with-logic/LoadingScreenWithLogic.tsx
// similar logic also exists in packages/editor/renderer/src/ui/Renderer/index.tsx
import React, { useEffect, useRef, useState } from 'react';
import { AIAnswerLoadingStreamMarkdownContainer, AIAnswerResultBlurSection } from './styled';
var MarkdownRenderer = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "react-markdown" */'react-markdown').then(function (_ref) {
    var ReactMarkdown = _ref.default;
    return {
      default: ReactMarkdown
    };
  });
});
var isScrolledToEnd = function isScrolledToEnd(element) {
  return !!element && Math.abs(element.scrollHeight - element.clientHeight - element.scrollTop) < 10;
};
export var AIAnswerLoadingStream = function AIAnswerLoadingStream(_ref2) {
  var markdown = _ref2.markdown;
  var containerRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showResultBlur = _useState2[0],
    setShowResultBlur = _useState2[1];
  useEffect(function () {
    var renderer = containerRef.current;
    var mutateTelepointer = function mutateTelepointer(mutations) {
      mutations.forEach(function () {
        if (containerRef && !showResultBlur && !isScrolledToEnd(containerRef.current)) {
          setShowResultBlur(true);
        }
      });
    };
    var observer = new MutationObserver(mutateTelepointer);
    observer.observe(renderer, {
      characterData: true,
      attributes: false,
      childList: true,
      subtree: true
    });
    return function () {
      return observer.disconnect();
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AIAnswerLoadingStreamMarkdownContainer, {
    ref: containerRef
  }, /*#__PURE__*/React.createElement(MarkdownRenderer, null, markdown)), showResultBlur && /*#__PURE__*/React.createElement(AIAnswerResultBlurSection, null));
};